module.exports = {
    controller: searchExplanatoryNotesGermanyController,
    templateUrl: 'search/components/pages/search-explanatory-notes-germany.html'
};

searchExplanatoryNotesGermanyController.$inject = [
    '$analytics', 
    '$location', 
    'notificationsService', 
    'dataContext', 
    'language', 
    'config', 
    'applicationStateService',
];

function searchExplanatoryNotesGermanyController(
    $analytics,
    $location, 
    notificationsService, 
    dataContext, 
    language, 
    config, 
    state
) {

    var vm = {
        $onInit: attached,
        $onDestroy: detached,
        isLoading: false,
        query: {
            QueryString: ''
        },
        results: [],
        scrollToDocument: scrollToDocument,
        search: search
    };

    return vm;

    function attached() {
        vm.query.QueryString = $location.search().query;
        $analytics.pageTrack('/explanatory-notes-germany-search');
        loadSearch();
        notificationsService.subscribe('filter_date_changed', loadSearch);
    }

    function detached() {
        notificationsService.unsubscribe('filter_date_changed', loadSearch);
    }

    function search(query) {
        $location.path('/search/explanatory-notes/germany').search(query);
    }

    function scrollToDocument(eztDocument) {
        document
            .querySelector('.DOC_' + eztDocument.HtmlClassName)
            .scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    function loadSearch() {
        var url = config.apiHosts.dtv + '/ezt/explanatory-notes/search' +
            '?lang=' + language.get() +
            '&q=' + vm.query.QueryString +
            '&date=' + state.filter.date;
        if (vm.query.QueryString && vm.query.QueryString.length > 1) {
            vm.isLoading = true;
            dataContext.get(url)
                .then(function (data) {
                    vm.isLoading = false;
                    vm.result = data;
                });
        }
    }
}